"use client"
import { useState } from 'react';

interface CodeBlockProps {
    code: string;
}

const CodeBlock: React.FC<CodeBlockProps> = ({ code }) => {
    const [copied, setCopied] = useState(false);

    const copyToClipboard = () => {
        navigator.clipboard.writeText(code).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <div className="relative mb-3 bg-gray-100 p-4 flex items-center rounded-lg">
            <pre className="flex !mb-0">{code}</pre>
            <button
                onClick={copyToClipboard}
                className="absolute right-2 top-1/2 transform -translate-y-1/2  px-2 py-1 rounded "
            >
                {copied ? 'Copied!' : 'Copy'}
            </button>
        </div>
    );
};

export default CodeBlock;
